const ErrorMessage = ({ message }) => {
  return <p className="text-signal-red-500 text-sm mt-1">{message}</p>;
};

export default ErrorMessage;
